export var UserRole;
(function (UserRole) {
    UserRole["ADMINISTRATOR"] = "Administrator";
    UserRole["SERVICE_USER"] = "ServiceUser";
})(UserRole || (UserRole = {}));
// user-role-query принимает int, а не строку роли: 1 - Administrator, 2 - ServiceUser.
export const USER_ROLE_QUERY_ID = {
    [UserRole.ADMINISTRATOR]: 1,
    [UserRole.SERVICE_USER]: 2,
};
